/**
 * employmentcheck/resources/js/main.js
 *
 * This is a file in which to place system-wide javascript
 * You should place any calls to doc ready in the ready.js file in this folder also so that there is only ever one place to look for this
 */

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date,
            args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
};


var csrfToken = $('meta[name="csrf-token"]').attr('content');


// Add forEach method to Arrays for IE8
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (fn, scope) {
        for (var i = 0, len = this.length; i < len; ++i) {
            fn.call(scope || this, this[i], i, this);
        }
    }
}


// Add bind method for IE8
if (!Function.prototype.bind) {
    Function.prototype.bind = function(oThis) {
        if (typeof this !== 'function') {
            // closest thing possible to the ECMAScript 5
            // internal IsCallable function
            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
        }

        var aArgs   = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            fNOP    = function() {},
            fBound  = function() {
                return fToBind.apply(this instanceof fNOP && oThis
                        ? this
                        : oThis,
                    aArgs.concat(Array.prototype.slice.call(arguments)));
            };

        fNOP.prototype = this.prototype;
        fBound.prototype = new fNOP();

        return fBound;
    };
}


/**
 * An object that abstracts a Bootstrap alert component - this is dismissible with a close button
 * @param {string} message     The message text to display
 * @param {string} messageType The bootstrap alert class - defaults toalert-success
 * @param {string} target      a DOM element to append the message alert to
 */
var AjaxAlert = function(message, messageType, target) {

    // Destroy any alerts that exist before adding another
    if ($('.alert').length) {
        $('.alert').remove();
    }

    if (undefined===messageType) {
        messageType = "alert-success";
    }
    if (undefined===target) {
        target = "body";
    }
    var markup = $('<div class="alert alert-dismissible fade in ajax-alert '+messageType+'"></div>');
    markup.text(message);
    markup.prepend('<button class="close" aria-label="Close" data-dismiss="alert" type="button"><span aria-hidden="true">×</span></button>');
    $(target).prepend(markup);
    setTimeout(function() {
        markup.alert('close');
    }, 5000);

};

(function($) {
    /**
     * A jQuery extension function to abstract a control that will submit the specified data (at the moment the form containing the element) via Ajax
     *
     * Attributes:
     *  - add a data-save-url to provide a different url from the form action of the containing form - default to # if no specified url
     *
     * Controller output
     *  - your controller should output Ajax with:
     *    - (boolean) status
     *    - (Array) messages - an array of messages to display
     *    - (Array) errors - an array of error messages to display
     *    - (Object) data - an object with the data that you saved (or failed to save) echoed back - the key of this object should be the data type of the object you saved
     *            eg: I'm saving a Tenant I get back
     *            data : {
     *                tenant : {
     *                    ...
     *                }
     *            }
     * @todo  - error handling needs to be implemented
     */
    $.fn.onPageSave = function() {
        this.on("click", function(e) {
            e.preventDefault();

            $('[data-role="validation-error"]').text("");

            var trigger = $(this);
            var ladda = Ladda.create(this);

            // look for a specified save url on the element itself first, then check if it in a form with a url, otherwise set it to #
            var saveUrl = (undefined !== trigger.data("saveUrl") ? trigger.data("saveUrl") : (undefined !== trigger.closest("form").attr("action") ? trigger.closest("form").attr("action") : "#"));

            var dataToSave = trigger.closest("form").serialize();

            $.ajax({
                type : "post",
                dataType : "json",
                url : saveUrl,
                data : dataToSave,
                success : function(output) {
                    ladda.stop();
                    if (undefined !== output.messages) {
                        for (var message in output.messages) {
                            new AjaxAlert(output.messages[message], "alert-success", "#messaging");
                        }
                    }

                    if (undefined !== output.errors) {
                        for (var error in output.errors) {
                            new AjaxAlert(output.errors[error], "alert-danger", "#messaging");
                        }
                    }

                    showValidationErrors(output.validationErrors);

                    //lock lockable fields again
                    $('[data-unlockable]').prop("readonly", true);
                },
                error : function(xhr, error, code) {
                    ladda.stop();
                }
            });

        });

        function showValidationErrors(validationErrors) {
            if (undefined===validationErrors) {
                return;
            }
            for (var k in validationErrors) {
                $('[data-role="validation-error"][data-for="'+k+'"]').text(validationErrors[k]);
            }
        }
    };

    /**
     * A nice file input combo that comprises a file browse selector with a text field to display the file selected
     * @return {[type]} [description]
     */
    $.fn.bootstrapFileSelector = function() {

        this.on('change', function() {
            var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
            input.trigger('fileselect', [numFiles, label]);
        });

        this.on('fileselect', function(event, numFiles, label) {
            var input = $(this).parents('.input-group').find(':text'),
                log = numFiles > 1 ? numFiles + ' files selected' : label;

            if( input.length ) {
                input.val(log);
            } else {
                if( log ) alert(log);
            }

        });
    };

    /**
     * Toggles a text input from a password input and back again
     * Markup:
     * add a data-role="password-flipper", wrap around a span to use as the trigger:
     * <div class="input-group-addon">
     *      <a data-role="password-flipper" href="#" data-toggle="tooltip" data-placement="bottom" title="toggle password visibility"><span class="fa fa-eye-open"></span> </a>
     *  </div>
     */
    $.fn.passwordFlipper = function() {
        this.on("click", function(e) {
            var p = $(this).closest("div.input-group").find("input");
            e.preventDefault();
            if (p.attr("type")=="text") {
                p.attr("type", "password");
            } else {
                p.attr("type", "text");
            }
            $(this).find("span").toggleClass("fa-eye");
            $(this).find("span").toggleClass("fa-eye-slash");
        });
    };

    /**
     * An input addon to toggle a field between readonly and writable
     * Markup:
     *
     */
    $.fn.fieldUnlocker = function() {
        this.each(function(i, e) {
            $(e).on("click", function(event) {
                event.preventDefault();
                var unlockableField = $(this).closest("div.form-group").find("[data-unlockable]");
                unlockableField.attr("readonly", !unlockableField.attr("readonly"));
            });
        });
    };


    $.fn.dirty = function(action) {

        switch (action) {
            case 'check':
                return ($(this).data('pluginDirty').serialize !== $(this).serialize());
        }

        return this.each(function() {


            switch (action) {
                case 'reset':
                    $(this).data('pluginDirty', null);
                    break;
            }

            if (undefined === $(this).data('pluginDirty') || !$(this).data('pluginDirty'))
            {
                $(this).data('pluginDirty', {
                    initialised: true,
                    serialize: $(this).serialize()
                });
            }
        });
    };



    $.fn.inlineContentEditor = function(saveCallback) {
        return this.each(function() {

            var editControl = $(this).find('a[data-role="edit-item"]');
            var saveControl = $(this).find('a[data-role="save-item"]');
            var cancelControl = $(this).find('a[data-role="cancel-item"]');
            var component = $(this);
            var saveUrl = $(this).data("saveUrl");
            var saveMethod = $(this).data("saveMethod");
            var inputType = $(this).data("inputType");

            function replaceSpans() {
                component.find('span[data-role="editable-content"]').each(function(i, e) {
                    var currentValue = $(this).attr("data-value")===undefined ? $(this).text() : $(this).attr("data-value");
                    var spanInputType = $(e).attr("data-input-type")===undefined ? "string" : $(e).data("inputType");
                    $(this).attr("data-cache",  $.trim(currentValue));
                    var func = "create"+(spanInputType.substr(0))+"Input";
                    //console.log(func);
                    $('<input data-input-type="'+spanInputType+'" data-role="editable-content" type="text" class="form-control" name="'+$(this).data("label")+'" value="'+$(this).attr("data-cache")+'" />').insertAfter($(this));
                    $(this).hide();
                });
            }

            function createStringInput(fromSpan) {
                //console.log("String", fromSpan);
            }

            function createEnumInput(fromSpan) {

            }

            function createBooleanInput(fromSpan) {

            }

            function replaceInputs() {
                component.find('input[data-role="editable-content"]').each(function(i, e) {
                    var span = $(this).siblings("span").show();
                    $(this).remove();
                });
            }

            function clearCache() {
                component.find('span[data-role="editable-content"]').removeAttr("data-cache");
            }

            function getSaveData() {
                var saveData = {};
                component.find('input[data-role="editable-content"]').each(function(i, e) {
                    saveData[e.name] = e.value;
                });
                return saveData;
            }

            function save(data) {

                return $.ajax({
                    "url" : saveUrl,
                    "method" : saveMethod === "" ? "post" : saveMethod,
                    "dataType" : "json",
                    "data" : data
                });
            }

            function handleReplacementValue(input, span) {
                span.attr("data-value", input.val());
                if (input.data("inputType")=="boolean") {
                    updateSpanClasses(span, input.val());
                } else {
                    span.text(input.val());
                }
            }

            function updateSpanClasses(span, value) {
                //console.log(value);
                if (parseInt(value)===1) {
                    span.addClass("fa-ok");
                    span.removeClass("fa-remove");
                } else {
                    span.removeClass("fa-ok");
                    span.addClass("fa-remove");
                }
                span.attr("data-value", value);
            }


            component.find('input[data-role="editable-content"]').on("focus", function() {
                editControl.show();
            });

            editControl.on("click", function(a) {
                a.preventDefault();
                saveControl.removeClass("hidden").show();
                cancelControl.removeClass("hidden").show();
                replaceSpans();
                $(this).hide();
            });

            cancelControl.on("click", function(b) {
                b.preventDefault();
                saveControl.hide();
                cancelControl.hide();
                editControl.show();
                replaceInputs();
                clearCache();
            });

            saveControl.on("click", function(c) {
                c.preventDefault();
                component.find('input[data-role="editable-content"]').each(function(i, e) {
                    handleReplacementValue($(e), $(this).siblings("span"));
                });
                $.when(save(getSaveData())).then(function(data, textStatus, jqXHR) {
                    replaceInputs();
                    clearCache();
                    saveControl.hide();
                    editControl.show();
                    cancelControl.hide();
                    if (undefined !== data.messages) {
                        for (var message in data.messages) {
                            new AjaxAlert(data.messages[message], "alert-success", "#messaging");
                        }
                    }

                    if (undefined !== data.errors) {
                        for (var error in data.errors) {
                            new AjaxAlert(data.errors[error], "alert-danger", "#messaging");
                        }
                    }
                });
            });

        });

    };

    $.fn.addRecord = function() {

        var $this = $(this);
        var textField = $this.find('input[type="text"]');
        var form = $this.find('form');
        var table = $this.closest('tbody');

        form.on('submit', function(e) {
            e.preventDefault();
            var dataToSave = form.serialize();
            var href = form.attr('action');

            $.ajax({
                url: href,
                type : "post",
                dataType : "json",
                data : dataToSave,
                success : function (output) {

                    if (undefined !== output.messages.success) {
                        for (var message in output.messages) {
                            new AjaxAlert(output.messages[message], "alert-success", "#messaging");
                        }

                        var label = output.data.output.label;
                        var id= output.data.output.id;

                        table.append("<tr id=\"dynamic-row-"+id+"\">" +
                            "<td>"+id+"</td>" +
                            "<td data-role=\"editable\">"+label+"</td>" +
                            "<td>"+output.data.output.creator+"</td>" +
                            "<td class=\"text-right\">" +
                            "    <form action=\""+href+"/"+id+"\" method=\"post\">" +
                            "        <input type=\"hidden\" name=\"_method\" value=\"DELETE\">" +
                            "        <input type=\"hidden\" name=\"_token\" value=\""+csrfToken+"\">" +
                            "        <div class=\"btn-group\" role=\"group\" style=\"width: 100%\">" +
                            "            <a data-role=\"edit-btn\" data-id=\""+id+"\" class=\"btn btn-primary btn-half-width\" href=\""+href+"/"+id+"/edit\"><span class=\"fa fa-cog\"></span> Edit</a>" +
                            "            <button class=\"delete btn btn-danger btn-half-width\" data-toggle=\"modal\" data-role=\"delete-confirmation\" data-target=\"#confirm-delete\" data-title=\"Delete Confirmation\" data-message=\"You are about to delete <strong class='username'>"+label+"</strong>. Are you sure?\" type=\"submit\">" +
                            "                <i class=\"fa fa-trash\"></i> Delete" +
                            "            </button>" +
                            "        </div>" +
                            "        <div class=\"btn-group hidden\" role=\"group\" style=\"width: 100%\">" +
                            "            <a data-role=\"save-btn\" data-style=\"slide-left\" data-id=\""+id+"\" class=\"btn btn-success btn-half-width\" href=\""+href+"/"+id+"\"><span class=\"fa fa-ok\"></span> Save</a>" +
                            "            <a data-role=\"cancel-btn\" class=\"btn btn-warning btn-half-width\" href=\"#\"><span class=\"fa fa-remove\"></span> Cancel</a>" +
                            "        </div>" +
                            "    </form>" +
                            "</td>" +
                            "</tr>");

                            $('tr#dynamic-row-'+id).editRecord();

                        if ($('#empty-message').length > 0) {
                            $('#empty-message').remove();
                        }

                        textField.val("");
                        return;
                    }

                    for (var error in output.errors) {
                        new AjaxAlert(output.errors[error], "alert-danger", "#messaging");
                    }

                    textField.focus();
                }
            });

        });

};

    $.fn.editRecord = function() {

        return this.each(function() {

            var $this = $(this);
            var editControl = $this.find('[data-role="edit-btn"]');
            var saveControl = $this.find('[data-role="save-btn"]');
            var cancelControl = $this.find('[data-role="cancel-btn"]');
            var editStateBtns = editControl.parent();
            var saveStateBtns = saveControl.parent();
            var editable = $this.find('[data-role="editable"]');

            editControl.on('click', function(e) {
                e.preventDefault();

                saveStateBtns.removeClass('hidden');
                editStateBtns.addClass('hidden');
                editable.html("<div class='input-group-sm'><input class='form-control' data-cache='"+editable.text()+"' type='text' value='"+editable.text()+"' name='location[label]'></div>");

            });

            $.ajaxSetup({
                headers: { 'X-CSRF-TOKEN': csrfToken }
            });

            saveControl.on('click', function(d) {
                d.preventDefault();
                $.ajax({
                    url: $(this).attr('href'),
                    type : "post",
                    dataType : "json",
                    data : { '_method' : 'PUT', 'label' : editable.find('input[type=text]').val() },
                    success: function(output) {
                        if (undefined !== output.messages.success) {
                            for (var message in output.messages) {
                                new AjaxAlert(output.messages[message], "alert-success", "#messaging");
                            }

                            editable.text(editable.find('input[type=text]').val());
                            saveStateBtns.addClass('hidden');
                            editStateBtns.removeClass('hidden');
                        }

                        for (var error in output.errors) {
                            new AjaxAlert(output.errors[error], "alert-danger", "#messaging");
                        }

                        editable.find('input[type=text]').focus();
                    }
                });
            });

            cancelControl.on('click', function(g) {
                g.preventDefault();
                saveStateBtns.addClass('hidden');
                editStateBtns.removeClass('hidden');
                editable.text(editable.find('input[type=text]').data('cache'));
            });

        });
    };

    /**
     * A select element that can filter elements with a data-filtered-by property that matches the selected option
     *
     * Uses the intersection of the applied filters with the select value of each filter on the page to create the correct filter
     * Dependency on underscore.js
     * Markup:
     * <select data-role="select-filter"> ....
     * ...
     * Items all marked up as:
     *
     * <tr data-role="inline-content-editor" data-filtered-by="matching_select options_to_display">
     */
    $.fn.selectFilter = function() {
        return this.each(function() {
            $(this).on("change", function() {
                var filteredValues = $.map($('[data-role="select-filter"]'), function(e,i) {
                    if ($(e).val()!="all") {
                        return $(e).val();
                    }
                });
                $("[data-filtered-by]").each(function(i,e) {
                    var applicableFilters = $(e).data("filteredBy").split(" "); //all the data-filtered-by attribute values from the filterable element
                    if (_.intersection(applicableFilters, filteredValues).length==filteredValues.length) {
                        $(e).show();
                    } else {
                        $(e).hide();
                    }
                });
            });
        });
    };

$.fn.copyToOrg = function() {
    return this.each(function(){
        var btn = $(this);
        var cached;
        btn.on('click', function() {
            var $this = $(this);
            var valueFrom = $($(this).data('value-from')).find(':selected');
            var copyTo = $($(this).data('copy-to'));

            // if (copyTo.attr('readonly') === true) {
            //     return;
            // }

            var copy = function() {
                cached = copyTo.val();
                copyTo.val($.trim(valueFrom.text()))
                    .attr('readonly', true);

                $this.html('<i class="fa fa-remove"></i> Remove from Organisation');
                $this.addClass('remove');
            };

            var remove = function() {
                copyTo.val(cached).attr('readonly', false);
                $this.html('<i class="fa fa-copy"></i> Copy to Organisation');
                $this.removeClass('remove');
            };

            if (!$this.hasClass('remove')) {
                copy();
            } else {
                remove();
            }
        });
    });
};

}(jQuery));

var Addresses = function($type) {

    var $this = this;

    if (!$type)
    {
        $type = $('[name="_type"]').val();
    }

    this.deleteAddress = function($hash, $row)
    {
        $.ajax({
            url: '/application/ajax/' + $type,
            type: 'post',
            dataType: 'json',
            data: {
                method: 'deleteAddress',
                hash: $hash,
                '_exists': $('[name="_exists"]').val()
            },
            success: function(json) {
                if (json.success)
                {
                    var $body = $row.parents('tbody');
                    $row.remove();

                    if (!$body.find('[data-address-id]').length)
                    {
                        $body.find('[data-role="no-previous-addresses"]').removeClass('hidden');
                    }

                    $this.updateAddressHistoryStatistics();
                }
            }
        });
    };

    this.loadNewAddress = function()
    {
        var $form = $('#modal-address');
        $('[name="address[until]"]').parents('.form-group').show();

        $form.find('[data-toggle="tooltip"]').tooltip('destroy');
        $form.find('.has-error').removeClass('has-error');

        $form.find(':input:not([data-fixed])').each(function() {

            var $field = $(this);
            var $value = '';

            if ($field.data('selectize'))
            {
                $field.selectize()[0].selectize.setValue($value);
            }
            else
            {
                $field.val($value);
            }
        });
    };

    this.loadPreviousAddress = function($id)
    {
        this.loadNewAddress();

        $.ajax({
            url: '/application/ajax/' + $type,
            type: 'post',
            dataType: 'json',
            data: {
                method: 'getAddress',
                id: $id
            },
            success: function(json) {

                if (!json.success)
                {
                    return;
                }

                if (json.address.current) {
                    $('[name="address[until]"]').parents('.form-group').hide();
                } else {
                    $('[name="address[until]"]').parents('.form-group').show();
                }

                for (var x in json.address)
                {
                    var $field = $('[name="address[' + x + ']"]');
                    var $value = json.address[x];

                    if (!$field.length)
                    {
                        continue;
                    }

                    if ($field.data('selectize'))
                    {
                        $field.selectize()[0].selectize.setValue($value);
                    }
                    else
                    {
                        $field.val($value);
                    }
                }
            }
        })
    };

    this.updateAddressHistoryStatistics = function()
    {
        $.ajax({
            url:'/application/ajax/' + $type,
            type:'post',
            dataType: 'json',
            data: {
                method: 'addressHistoryStatistics',
                '_exists': $('[name="_exists"]').val()
            },
            success: function(json) {

                $('#messaging').remove();

                $('[data-variable="address.years"]').text(json.years);
                $('[data-variable="address.months"]').text(json.months);

                var $addressRanges = $('[data-variable="address.ranges"]');
                $addressRanges.find('li').remove();

                if (!json.addressHistoryGaps.length)
                {
                    $('[data-variable="address.stats.error"]').addClass('hidden');
                    $('[data-variable="address.stats.info"]').removeClass('hidden');
                    $('[data-variable="buttons.continue"]').removeClass('hidden');
                    return;
                }

                $('[data-variable="address.stats.error"]').removeClass('hidden');
                $('[data-variable="address.stats.info"]').addClass('hidden');
                $('[data-variable="buttons.continue"]').addClass('hidden');

                for (var x in json.addressHistoryGaps)
                {
                    var $range = json.addressHistoryGaps[x];

                    //console.log($range);

                    $addressRanges.append(
                        $('<li>').text($range.from + ' - ' + $range.until)
                    );
                }
            }
        });
    };
};


/**
 * Queue object for handling linked alerts with notie.js.
 */
var Queue = {


    /**
     * Store all queue items.
     *
     * @type Array
     */
    items: [],

    previousItem: "",


    /**
     * Store interval for item queue.
     */
    queue: null,


    /**
     * Specify if current queue item must be waited for.
     *
     * @type boolean
     */
    wait: false,


    /**
     * Estimate time in seconds which it should take to read
     * the passed text. Based on 180 words per minute average.
     * Minimum of two seconds for any text.
     *
     * @param $text
     * @returns {number}
     */
    readingSpeed: function($text)
    {
        var $averageWpm = 180;
        var $words = $text.split(/\s+/).length;
        var $time = 60 / ($averageWpm / $words);

        if ($time < 3)
        {
            return 3;
        }

        return $time;
    },


    hide: function()
    {
        clearTimeout(this.queue);
        this.items = [];

        notie.hide();
    },

    /**
     * Process all outstanding items in the message queue.
     */
    processQueue: function()
    {
        if (!this.items.length)
        {
            return;
        }

        this.previousItem = this.items[this.items.length-1];


        // If there is a prioritised item in the queue, we wait for it to finish.
        if (this.queue && this.wait)
        {
            return;
        }

        var $current = this.items.shift();

        if ($current.wait)
        {
            this.wait = true;
        }


        // Clear the queue
        clearTimeout(this.queue);

        var $this = this;

        this.queue = setTimeout(function()
        {
            var $seconds = $this.readingSpeed($current.message);

            if (typeof $current.open === 'function')
            {
                $current.open();
            }

            if ($('[name="show_id_verifier_banner"]').val() == "1") {
                notie.alert($current.type, $current.message,
                    $seconds * (typeof $current.infinite !== 'undefined' && !$current.infinite ? 1 : 1000)
                );
            }


            // If a priority message, process queue only when it is finished.
            if ($this.wait)
            {
                setTimeout(function() {
                    $this.wait = false;
                    $this.processQueue();
                }, $seconds * 1000);
            }

        }, 500);
    },


    /**
     * Add an item to the queue.
     *
     * Pass object { type: 1|2|3|4, message: string, wait: boolean }
     *
     * @param item
     */
    addItem: function(item)
    {
        this.items = [];
        this.items.push(item);
        this.processQueue()
    },

    getPrevious: function() {
        return this.previousItem;
    }
    
};


/**
 * Wraps a class with an event interface allowing you to
 * fire an event on every method call.
 *
 * @param $class
 * @param $exclude
 * @returns {Function}
 * @constructor
 */
var Eventable = function($class, $exclude)
{


    // Binds a callback after initial method has been fired
    var after = function(object, method, fn) {

        var originalMethod = object[method];

        object[method] = function () {
            var $return = originalMethod.apply(object, arguments);
            var fna = fn.bind(object);
            fna(method);

            return $return;
        };
    };

    return function()
    {
        var $events = {};


        /**
         * Register an event into the events array.
         *
         * @param method
         * @param callback
         */
        this.registerEvent = function(method, callback)
        {
            var $this = this;

            if (method.constructor === Array)
            {
                method.forEach(function(item) {
                    $this.registerEvent(item, callback);
                });

                return;
            }

            if (!$events[method])
            {
                $events[method] = [];
            }

            $events[method].push(callback.bind(this));
        };


        // Merge old class into new function
        $class.apply(this);

        for (x in this)
        {
            $events[x] = [];
        }


        // Loop through all methods which have events and fire said events when method called
        for (x in this)
        {
            if ($exclude && $exclude.indexOf(x) >= 0)
            {
                continue;
            }

            after(this, x, function(method) {

                $events[method].forEach(function(item)
                {
                    item();
                });
            })
        }
    }
};


/**
 * National insurance number validation
 */
var NationalInsuranceNumber = function($nino)
{
    this.setNino = function($number)
    {
        $nino = $number;
    };

    this.isValid = function()
    {
        return /([ABCEGHJKLMNOPRSTWXYZ][ABCEGHJKLMNPRSTWXYZ]|OO|CR|FY|MW|NC|PP|PZ|TN)([0-9]{6})([ABCD])/i
            .test($nino.toString());
    };
};

NationalInsuranceNumber = Eventable(NationalInsuranceNumber);


/**
 * UK Driving licence validation
 */
var UkDrivingLicence = function($licenceNumber)
{
    this.setNumber = function($number)
    {
        if (typeof $number !== 'string') {
            return;
        }

        $licenceNumber = $number.toString().replace(/[^A-Z0-9]+/i, '').toUpperCase();

        return this;
    };

    this.setNumber($licenceNumber);

    var $errors = [];

    var $driver = {
        surname: null,
        dob: null,
        forenames: [],
        gender: null
    };

    this.setSurname = function($surname)
    {
        $driver.surname = $surname;

        return this;
    };

    this.setDateOfBirth = function($date)
    {
        if (Object.prototype.toString.call($date) !== '[object Date]')
        {
            return this;
        }

        $driver.dob = $date;

        return this;
    };

    this.setGender = function($gender)
    {
        $driver.gender = $gender;

        return this;
    };

    this.getDriver = function()
    {
        return $driver;
    }

    this.setForenames = function($forenames)
    {
        $driver.forenames = $forenames;

        return this;
    };

    this.setFirstName = function(firstName)
    {
        $driver.firstName = firstName;

        return this;
    }

    this.setMiddleName = function(middleName)
    {
        $driver.middleName = middleName;

        return this;
    }

    this.isValid = function()
    {
        if ($licenceNumber.length < 16) {
            return true;
        }

        $errors = [];
        var $tempLicenceNumber = $licenceNumber + '';

        if (!/^[A-Z0-9]{5}[0-9]{6}[A-Z0-9]{2}[0-9][A-Z0-9]{2}([0-9]{2})?$/.test($licenceNumber))
        {
            $errors.push('UK driving licence number does not match a valid format.');
            $errors.push($licenceNumber);
            return false;
        }

        var $licenceParts = [];
        [5,6,2,1,2,2].forEach(function($length) {
            var $section = $tempLicenceNumber.substring(0, $length);

            if ($section.length < $length)
            {
                $section = null;
            }

            $licenceParts.push($section);
            $tempLicenceNumber = $tempLicenceNumber.substring($length);
        });

        var $parts = [
            'name',
            'date',
            'initials',
            'check'
        ];

        var $licenceSections = {};

        for (var $x in $parts)
        {
            var $part = $parts[$x];

            if (!$licenceParts[$x])
            {
                $errors.push('UK driving licence ' + $part + 'does not exist.');
                return false;
            }

            $licenceSections[$part] = $licenceParts[$x];
        }

        if ($driver.surname)
        {
            var $surnameCheck = $driver.surname.replace(/'/g, '');
            $surnameCheck = $surnameCheck.replace(/\s/g, '');
            $surnameCheck = $surnameCheck.replace(/^Mac/g, 'Mc');
            $surnameCheck = ($surnameCheck + '99999999').substring(0,5).toUpperCase();

            if (!/^[A-Z]{1}[A-Z]{0,4}[0-9]{0,4}$/.test($licenceSections.name))
            {
                $errors.push('UK driving licence name does not match valid format. Please double check the licence number.');
            }
            else if ($surnameCheck !== $licenceSections.name)
            {
                $errors.push('UK driving licence name does not match the full name stated on the application. The first 5 letters of the license number must be the first 5 letters of the driver\'s surname. If the surname is less than 5 characters, the remaining spaces must be filled with the number 9.');
            }
        }

        if ($driver.firstName)
        {
            check = $driver.firstName.substring(0,1).toUpperCase();

            if (check !== $licenceNumber.substring(11,12).toUpperCase())
            {
                $errors.push('UK driving licence initials do not match driver names. The 12th and 13th characters must be the first and middle initials of the driver’s name. If the driver does not have a middle name, the 13th character should show as the number 9 instead.');
            }
        }

        if ($driver.middleName)
        {
            check = $driver.middleName.substring(0,1).toUpperCase();
        } else {
            check = '9';
        }

        if (check !== $licenceNumber.substring(12,13).toUpperCase())
        {
            $errors.push('UK driving licence initials do not match driver names. The 12th and 13th characters must be the first and middle initials of the driver’s name. If the driver does not have a middle name, the 13th character should show as the number 9 instead.');
        }

        if ($driver.gender)
        {
            if (['male', 'female'].indexOf($driver.gender) < 0)
            {
                $errors.push('Please check the 7th character of the licence number. This should show as 0,1,5 or 6 dependant on applicant gender (0 or 1 for male and 5 or 6 for female)');
            }
            else
            {
                var $genderFlag = $licenceSections.date.substring(1,2);

                if ((['5', '6'].indexOf($genderFlag) >= 0 && $driver.gender !== 'female') ||
                    (['1', '0'].indexOf($genderFlag) >= 0 && $driver.gender !== 'male'))
                {
                    $errors.push('Please check the 7th character of the licence number. This should show as 0,1,5 or 6 dependant on the gender, but does not match gender stated on the application. (0 or 1 for male and 5 or 6 for female)');
                }
            }
        }

        if ($driver.dob)
        {

            var $year = $driver.dob.getFullYear().toString().substring(2);
            var $month = ($driver.dob.getMonth() + 1).toString();
            var $day = $driver.dob.getDate().toString();

            if ($month.length < 2)
            {
                $month = '0' + $month;
            }

            if ($day.length < 2)
            {
                $day = '0' + $day;
            }

            if (!/^[0-9]{6}$/.test($licenceSections.date))
            {
                $errors.push('Please check the 6th to 11th characters of the licence number. These must all consist of numbers, as reflects the applicant’s date of birth.')
            }
            else
            {
                if ($driver.gender === 'female')
                {
                    $month = (parseInt($month.substring(0,1)) + 5).toString() + $month.substring(1);
                }

                var $dateCheck = $year.substring(0,1) + $month + $day + $year.substring(1);

                if ($dateCheck !== $licenceSections.date)
                {
                    $errors.push('Please check the 6th and 11th characters of the licence number. These must all consist of numbers, as reflects the applicant’s year of birth. E.g. If the year of birth is 1980, the 6th and 11th digits would show as the following; SMITH857220D99AZ 12.');
                }
            }
        }

        // Unsure about the validity of this check
        // if (!/^[2-9]$/.test($licenceSections.check))
        // {
        //     $errors.push('UK driving licence tiebreaker is not valid. Please double check you have entered the licence number correctly.');
        // }

        return !$errors.length;
    };

    this.getLicenceNumber = function()
    {
        return $licenceNumber;
    };

    this.getErrors = function()
    {
        return $errors;
    };
};

UkDrivingLicence = Eventable(UkDrivingLicence);


var UkDrivingLicenceTestSuite = function()
{
    var $licence;
    var $tests = 0;
    var $passed = 0;

    var setup = function()
    {
        $licence = new UkDrivingLicence();
        $licence.setNumber('MONTA901010A92BC');
        $licence.setSurname('Montana');
        $licence.setDateOfBirth(new Date('1990-01-01'));
        $licence.setForenames(['Antonio']);
        $licence.setGender('male');
    };

    setup();

    var assert = function($test, $description)
    {
        $tests++;
        $passed += $test ? 1 : 0;
        setup();
        //console.log($description + ':' , $test ? 'passed' : 'failed');
    };

    assert($licence.isValid(), 'Check valid licence is valid');

    $licence.setGender('female');
    assert(!$licence.isValid(), 'Check licence has invalid gender');

    $licence.setForenames(['Tony']);
    assert(!$licence.isValid(), 'Check licence has invalid forenames');
    assert($licence.isValid(), 'Check original licence is still valid');

    setup = function()
    {
        $licence = new UkDrivingLicence();
        $licence.setNumber('GIRL9051010A95II');
        $licence.setSurname('Girl');
        $licence.setDateOfBirth(new Date('2000-01-01'));
        $licence.setForenames(['Anna']);
        $licence.setGender('female');
    };

    setup();

    assert($licence.isValid(), 'Check female licence is valid');

    $licence.setGender('male');
    assert(!$licence.isValid(), 'Check female licence with male gender is invalid');

    $licence.setForenames(['Anna', 'Bell']);
    assert(!$licence.isValid(), 'Check licence initials are invalid');

    setup();

    $licence.setNumber('GIRL9051010A95II11');
    assert($licence.isValid(), 'Check issue number is valid');
    $licence.setNumber('GIRL9051010A95II');
    assert($licence.isValid(), 'Check number is valid without issue number');
    $licence.setNumber('GIRL9051010A95II1');
    assert(!$licence.isValid(), 'Check number is invalid with short issue number');
    $licence.setNumber('GIRL9051010A95IIAA');
    assert(!$licence.isValid(), 'Check number is invalid with non numeric issue number');

    //console.log($tests + ' tests run with ' + $passed + ' passing.');
};

/**
 * Basic ID verification class
 */
var BasicIdVerification = function()
{
    var $documents = 0;

    var $currentAddress = false;

    var $confirmation = false;

    this.currentAddressChecked = function()
    {
        return $currentAddress;
    }

    this.confirmed = function()
    {
        return $confirmation;
    }

    this.setDocuments = function($numberOfDocuments)
    {
        $documents = $numberOfDocuments;

        return this;
    };

    this.isValid = function()
    {
        return $documents >= 3 /*&& $currentAddress && $confirmation*/;
    };

    this.getErrors = function()
    {
        var $messages = [];

        if ($documents < 3)
        {
            var $message = 'At least three documents are required.';

            switch (3 - $documents)
            {
                case 1:
                    $message = 'One more document required.';
                    break;

                case 2:
                    $message = 'Two more documents required.';
                    break;
            }
        }

        if ($documents >= 3)
        {

            if (!$confirmation)
            {
                //$message = 'Please confirm that the information provided is complete and true';
            }

            if (!$currentAddress)
            {
                //$message = 'Please verify that you have checked current address, date of birth, name and address history';
            }

        }

        $messages.push($message);

        return $messages;
    };

    this.triggerValidation = function()
    {

    };

    this.hasCurrentAddressInDocuments = function($hasCurrentAddress)
    {

        $currentAddress = $hasCurrentAddress;

        return this;
    };

    this.hasConfirmation = function($hasConfirmation)
    {

        $confirmation = $hasConfirmation;

        return this;
    };

};

BasicIdVerification = Eventable(BasicIdVerification);


/**
 * Route class for ID Verification
 */
var IdVerificationRoute = function()
{
    var $groupCounts = {
        one: 0,
        twoA: 0,
        twoB: 0
    };
    var $route = 0;
    var $noGroup1 = false;

    var $hadExternalValidation = false;
    var $failedExternalValidation = false;
    var $ukChannelIslandBirthCertificate = false;
    var $currentAddress = false;
    var $confirmation = false;
    var $errorMessages = [];

    this.currentAddressChecked = function()
    {
        return $currentAddress;
    }

    this.confirmed = function()
    {
        return $confirmation;
    }

    var calculateRoute = function()
    {
        if ($groupCounts.one >= 1)
        {
            $route = 1;
            $noGroup1 = false;
        }
        else
        {
            if ($hadExternalValidation ? !$failedExternalValidation : true)
            {
                $route = 2;
            }
            else
            {
                $route = 3;
            }
        }

        if ($groupCounts.one === 0 && $groupCounts.twoA === 0 && $groupCounts.twoB === 0)
        {
            $route = 1;
        }

        if ($noGroup1 && $route === 1)
        {
            $route = 2;
        }

        if ($route !== 1 && $hadExternalValidation && $failedExternalValidation)
        {
            $route = 3;
        }

        return $route;
    };

    this.setNoGroup1 = function($val)
    {
        $noGroup1 = $val;

        return this;
    };

    this.toggleExclusiveDocuments = function () {

        var $documents = [
            [
                '#driving-licence',
                '#driving-licence-outside-eu',
                '#driving-licence-paper'
            ],
            [
                '#birth-certificate-at-birth',
                '#birth-certificate-after-birth'
            ]
        ];

        $documents.forEach(function ($setOfDocuments) {

            var anyChecked = false;

            $setOfDocuments.forEach(function ($document) {
                var $element = $($document);
                $element.removeAttr('disabled');

                if ($element.is(':checked')) {
                    anyChecked = true;
                }
            });

            if (anyChecked) {

                //console.log('Some checked', $setOfDocuments);

                $setOfDocuments.forEach(function (lookedElement) {
                    var $element = $(lookedElement);
                    if (!$element.is(':checked')) {
                        //console.log('Disabling',lookedElement);
                        $(lookedElement).attr('disabled', 'disabled');
                    }
                });
            }
        });
    };

    this.setGroups = function($group1, $group2a, $group2b)
    {
        $groupCounts = {
            one: $group1,
            twoA: $group2a,
            twoB: $group2b
        };
    };

    this.undoExternalValidation = function()
    {
        $hadExternalValidation = false;
        $failedExternalValidation = false;

        return this;
    };

    this.hasCurrentAddressInDocuments = function($hasCurrentAddress)
    {
        $currentAddress = $hasCurrentAddress;

        return this;
    };

    this.hasConfirmation = function($hasConfirmation)
    {
        $confirmation = $hasConfirmation;

        return this;
    };

    this.setExternalValidationResult = function($pass)
    {
        return this.setExternalValidationResultWithoutNotification($pass);
    };

    this.triggerEvents = function() {};

    this.setExternalValidationResultWithoutNotification = function($pass)
    {
        $hadExternalValidation = true;
        $failedExternalValidation = !$pass;

        return this;
    };

    this.hadExternalValidation = function()
    {
        return $hadExternalValidation;
    };

    this.passedExternalValidation = function()
    {
        return !$failedExternalValidation;
    };

    this.setUkOrChannelIslandsBirthCertificate = function($hasCertificate)
    {
        $ukChannelIslandBirthCertificate = $hasCertificate;

        return this;
    };

    this.hasUkOrChannelIslandsBirthCertificate = function()
    {
        return $ukChannelIslandBirthCertificate;
    };

    this.getRoute = function()
    {
        return calculateRoute();
    };

    this.validateGroup1AdditionalDetails = function()
    {
        // Remove all field alerts before checking
        $('div.field-alert').remove();

        var $passport = $('input#passport');
        var $drivingLicence = $('input#driving-licence');
        var $birthCertificate = $('input#birth-certificate-at-birth');

        var $message = {
            valid: true,
            fields: [],
            groupings: {},
            message: ''
        };

        var validate = {
            date: function($val) { return moment($val, 'DD/MM/YYYY').isValid('DD/MM/YYYY'); },
            dateOfIssue: function($val)
            {
                var date = moment($val, 'DD/MM/YYYY');
                var applicantDob = moment($('input[data-applicant-dob]').data('applicant-dob'), 'DD/MM/YYYY');
                if (date.isValid()) {
                    if (!date.isAfter(applicantDob)) {
                        $message.message = 'Issue date cannot be earlier or the same as date of birth.';
                        return false;
                    }
                    return true;
                }
                return false;
            },
            dateOfBirth: function($val, $element)
            {
                var applicantDob = moment($('input[data-applicant-dob]').data('applicant-dob'), 'DD/MM/YYYY');
                if (moment($val, 'DD/MM/YYYY').isValid('DD/MM/YYYY'))
                {
                    if(!moment($val, 'DD/MM/YYYY').isSame(applicantDob)) {
                        $message.message = 'Date of birth must be the same as provided by Applicant.';
                        return false;
                    }
                    return true;
                }
                return false;
            },
            drivingLicenceNumber: function($val, $element)
            {

                var countryOfIssue = $('select[name="driving_licence[driving_licence_country]"]');
                if (countryOfIssue[0].selectize.getValue() !== "United Kingdom" && $val !== "")
                {

                    return true; //Validate if it's not a british license
                }

                var $licence = new UkDrivingLicence();
                $licence.setNumber($val);
                var $dob = $('[data-license="dob"]').val();
                $licence.setDateOfBirth(moment($dob, 'DD/MM/YYYY').toDate());
                //$licence.setForenames($element.data('forenames'));
                $licence.setSurname($('[data-license="surname"]').val());
                $licence.setGender($('[data-license="gender"]').val());
                $licence.setFirstName($('[data-license="firstName"]').val());
                $licence.setMiddleName($('[data-license="middleName"]').val());

                window.licenseTest = $licence;

                var result = $licence.isValid();
                if (!result) {
                    $message.message = $licence.getErrors().toString();
                }
                return result;
            },
            passport: function ($val) {
                var $nationality = $('[name="passport[nationality]"]').val();

                if ($nationality === "United Kingdom" || $nationality === "UK") {
                    if (!$val.match(/^[0-9]{9}$/)) {
                        $message.message = 'British passport number must consist of 9 digits.';
                        return false;
                    }
                    return true;
                }

                return $val.match(/^[0-9]{9,11}$/);
            }
        };

        var validateFields = function($fields, $prefix, $group)
        {
            $fields.forEach(function($field) {

                $message.message = '';

                var $callback = function($val)
                {
                    return !!$val.trim();
                };

                if ($.isArray($field))
                {
                    var $data = $field;
                    $field = $data[0];
                    $callback = $data[1];
                }

                var $element = $('[name="' + $prefix + '[' + $field + ']"]');
                var $value = $element.val();
                var $valid = $callback($value, $element);

                //&= bitwise checking against an array  - evaluates false so use !! to cast to boolean first

                $message.valid &= !!$valid;


                if (!$valid) {
                    $message.groupings[$group] = true;
                    $message.fields.push($prefix + '[' + $field + ']');


                    if ($message.message.length) {

                        var parentElement = $element.parent();

                        if (!parentElement.hasClass('input-group')) {
                            parentElement = $element;
                        }

                        parentElement.after('<div class="alert alert-danger field-alert" style="margin-top: 5px;">'+
                                $message.message+
                            '</div>'
                        );

                    }
                }
            });
        };

        if ($passport.is(':checked'))
        {
            var $passportFields = [
                ['passport_number', validate.passport],
                'nationality',
                ['date_of_issue', validate.dateOfIssue],
                ['date_of_birth', validate.dateOfBirth]
            ];

            validateFields($passportFields, 'passport', 'passport');
        }

        if ($drivingLicence.is(':checked'))
        {
            var $drivingLicenceFields = [
                ['driving_licence_number', validate.drivingLicenceNumber],
                ['valid_from', validate.dateOfIssue],
                ['date_of_birth', validate.dateOfBirth]
            ];

            validateFields($drivingLicenceFields, 'driving_licence', 'driving licence');
        }

        if ($birthCertificate.is(':checked'))
        {
            var $birthCertificateFields = [
                ['date_of_issue', validate.dateOfIssue],
                ['date_of_birth', validate.dateOfBirth]
            ];

            validateFields($birthCertificateFields, 'birth_certificate', 'birth certificate');
        }

        return $message;
    };

    this.highlightAdditionalDetails = function()
    {
        var $details = this.validateGroup1AdditionalDetails();
        //
        // $('[data-group="group-1"] input[name]').parents('.form-group').removeClass('has-warning has-error');
        //
        // $details.fields.forEach(function($field) {
        //     $('[name="' + $field + '"]').parents('.form-group').addClass('has-error');
        // });

        return $details;
    };

    this.triggerValidation = function() {};

    this.isValidRoute = function()
    {
        $errorMessages = [];
        var $valid = false;

        switch ($route)
        {
            case 1:

                if (($groupCounts.one - 1) + $groupCounts.twoA + $groupCounts.twoB < 2)
                {
                    $errorMessages.push('Applicant must provide at least one document from Group 1, and 2 further documents from either Group 1, Group 2a or Group 2b. At least one of the documents must show the applicant\'s current address.');
                }
                else
                {
                    $errorMessages.push('An acceptable number of documents have been entered to complete Route 1.');
                }

                var $additionalDetailsCheck = this.highlightAdditionalDetails();

                

                if (!$additionalDetailsCheck.valid && $additionalDetailsCheck.groupings)
                {
                    var $headings = [];
                    for (var $heading in $additionalDetailsCheck.groupings)
                    {
                        $headings.push($heading);
                    }

                    $errorMessages.push('There are incomplete fields in the ' + $headings.join(', ') + ' section'
                        + ($additionalDetailsCheck.groupings.length === 1 ? '' : 's') + '.');
                }

                //console.log($additionalDetailsCheck.valid);

                $valid = $additionalDetailsCheck.valid
                    && $groupCounts.one >= 1
                    && ($groupCounts.one - 1) + $groupCounts.twoA + $groupCounts.twoB >= 2;
                break;

            case 2:

                if ($groupCounts.twoA < 1 || ($groupCounts.twoA - 1) + $groupCounts.twoB < 2)
                {
                    $errorMessages.push('The Applicant must provide one document from Group 2a, and 2 further documents from either Group 2a or Group 2b. At least one of the documents must show the applicant\'s current address. An External Validation check will also be required to be completed for this route.');
                }
                else
                {
                    $errorMessages.push('An acceptable number of documents have been entered to complete Route 2.');
                }

                $valid = $groupCounts.twoA >= 1 && ($groupCounts.twoA - 1) + $groupCounts.twoB >= 2;
                break;

            case 3:

                if ($groupCounts.twoA < 1 || $groupCounts.twoA + $groupCounts.twoB < 5)
                {
                    $errorMessages.push('The Applicant must provide one document from Group 2a, and 3 further documents from either Group 2a or Group 2b. At least one of the documents must show the applicant\'s current address.');
                }
                else
                {
                    $errorMessages.push('An acceptable number of documents have been entered to complete Route 3.');
                }

                if (!$ukChannelIslandBirthCertificate)
                {
                    $errorMessages.push('Applicant must have a valid UK and Channel Islands birth certificate from Group 2a issued after the time of birth.')
                }

                $valid = $groupCounts.twoA >= 1 && $groupCounts.twoA + $groupCounts.twoB >= 5
                    && $ukChannelIslandBirthCertificate;
                break;
        }

        if (!$currentAddress)
        {
            //$errorMessages.push('Please tick to confirm you have checked the current address, date of birth, name and address history.');
            //return false;
        }

        if (!$confirmation)
        {
            //$errorMessages.push('You must confirm that the information provided is accurate.');
            //return false;
        }

        return $valid;
    };

    this.getInvalidGroupErrors = function()
    {
        return $errorMessages;
    };
};

IdVerificationRoute = Eventable(IdVerificationRoute, [
    'registerEvent',
    'getEvents'
]);

/**
 * Init function to set up popover "Are you Sure" functionality on delete controls - note this is different from the confirm action that requires re-entering the user password
 * KCC have confirmed that they will want to replace those older style confirmation actions with this message in the post live phase
 * @return {[type]} [description]
 */
function initConfirmActions() {

    $('[data-role="confirm-action"]').on("click", function(e) {
        e.preventDefault();
        var trigger = $(e.target).closest("a");
        var actionUrl = trigger.attr("href");
        var confirm = $('<a class="btn btn-xs btn-danger" href="'+actionUrl+'"><i class="fa fa-check"></i></a>');
        var cancel = $('<a class="btn btn-xs btn-success" href="#"><i class="fa fa-remove"></i></a> ');
        var content = $('<span>'+$(trigger).data("confirmMessage")+'</span>');
        content.append("&nbsp;").append(confirm).append("&nbsp;").append(cancel);
        cancel.on("click", function(c) {
            c.preventDefault();
            $(trigger).popover('destroy');

        });
        $(trigger).popover({
            "placement" : "top",
            "html" : "true",
            "title" : "<span class='text-info'><strong>Are you sure?</strong></span>",
            "content" : content
        });
        $(trigger).popover('show');
    });
}

/**
 * Show an info panel when the trigger point select is changed in the email configurator
 * Specifically applies to referee emails but can be adapted to use any trigger point - just add the trigger point and the matching message to the triggerWarnings object
 * Bound to the trigger_point dropdown on the email config screen
 */
function initTriggerPointWarnings() {

    var triggerWarnings = {
            "awaiting-referees-primary-chase" : "At this trigger point a single email will be sent per referee",
            "awaiting-referees-secondary-chase" : "At this trigger point a single email will be sent per referee",
            "awaiting-referees-status" : "At this trigger point a single email will be sent per referee"
        };

    var trigger = $('select[name="trigger_point"]');

    //show if already selected as trigger point
    showWarning(trigger.val());

    function showWarning(triggerPoint) {
        $('#trigger-warning').remove();
        var warningBox = $('<div class="alert alert-info" id="trigger-warning">');
        if (triggerWarnings[triggerPoint]!==undefined) {
            warningBox.append(triggerWarnings[triggerPoint]);
            warningBox.insertAfter(trigger.closest("div.form-group"));
        }
        
    }

    //respond to select value changes
    $('select[name="trigger_point"]').on("change", function(e) {
        showWarning($(this).val());
    });
}

/**
 * Toggles the Barred List Check Status dropdown in dbs edit
 */
var list99Toggle = function() {
    
    var panel = $('[data-role="list99status"]').closest('.panel');
    var radioBtn = $('[name="seperate_barred_list_req"]');

    var toggle = function(el) {
        if(!parseInt(el.val())) {
            panel.hide();
        } else {
            panel.show();
        }
    }

    radioBtn.on('click', function() {
        toggle($(this));
    });

    toggle($('[name="seperate_barred_list_req"]:checked'));
}